import { render, staticRenderFns } from "./GlobalHeader.vue?vue&type=template&id=12100dba&scoped=true&lang=pug&"
import script from "./GlobalHeader.vue?vue&type=script&lang=ts&"
export * from "./GlobalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalHeader.vue?vue&type=style&index=0&id=12100dba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12100dba",
  null
  
)

export default component.exports